import { Pipe, PipeTransform } from '@angular/core'
import { clamp } from '@mos/shared/utils'

@Pipe({
	name: 'clamp',
	pure: true,
})
export class ClampPipe implements PipeTransform {
	transform(value: number, min: number = 0, max: number = 1): number {
		return clamp(value, min, max)
	}
}
